import { FishRarity } from '~/shared';
import { IHobbyFishingDifficulty } from './gameFishingServiceTypes';

export const FISHING_DIFFICULTY_BY_RARITY: Record<
	FishRarity,
	IHobbyFishingDifficulty
> = {
	[FishRarity.COMMON]: {
		startProgressMin: 25,
		startProgressMax: 35,
		holdGainMin: 0.2,
		holdGainMax: 0.4,
		idleDrainMin: 0.1,
		idleDrainMax: 0.4,
		tugGainMin: 1,
		tugGainMax: 3,
		tugDrainMin: 0.1,
		tugDrainMax: 0.4,
		phaseSwitchMsMin: 2000,
		phaseSwitchMsMax: 6000,
		wrongControlFullRedSec: 4,
	},
	[FishRarity.RARE]: {
		startProgressMin: 20,
		startProgressMax: 30,
		holdGainMin: 0.15,
		holdGainMax: 0.35,
		idleDrainMin: 0.15,
		idleDrainMax: 0.5,
		tugGainMin: 0.8,
		tugGainMax: 2.5,
		tugDrainMin: 0.15,
		tugDrainMax: 0.5,
		phaseSwitchMsMin: 1500,
		phaseSwitchMsMax: 5000,
		wrongControlFullRedSec: 3,
	},
	[FishRarity.TROPHY]: {
		startProgressMin: 15,
		startProgressMax: 25,
		holdGainMin: 0.1,
		holdGainMax: 0.3,
		idleDrainMin: 0.2,
		idleDrainMax: 0.6,
		tugGainMin: 0.6,
		tugGainMax: 2,
		tugDrainMin: 0.2,
		tugDrainMax: 0.6,
		phaseSwitchMsMin: 1000,
		phaseSwitchMsMax: 3500,
		wrongControlFullRedSec: 2.5,
	},
	[FishRarity.FORBIDDEN]: {
		startProgressMin: 10,
		startProgressMax: 20,
		holdGainMin: 0.1,
		holdGainMax: 0.25,
		idleDrainMin: 0.25,
		idleDrainMax: 0.75,
		tugGainMin: 0.5,
		tugGainMax: 1.6,
		tugDrainMin: 0.25,
		tugDrainMax: 0.75,
		phaseSwitchMsMin: 800,
		phaseSwitchMsMax: 2500,
		wrongControlFullRedSec: 2,
	},
};

export const DEFAULT_FISHING_DIFFICULTY =
	FISHING_DIFFICULTY_BY_RARITY[FishRarity.COMMON];

export function getFishingDifficultyByRarity(
	rarity?: FishRarity | null,
): IHobbyFishingDifficulty {
	if (!rarity) {
		return DEFAULT_FISHING_DIFFICULTY;
	}

	return FISHING_DIFFICULTY_BY_RARITY[rarity] ?? DEFAULT_FISHING_DIFFICULTY;
}
